<template>
  <div class="content">
    <f7-list strong-ios dividers-ios inset-ios>
      <f7-list-input
        type="text"
        placeholder="please input username"
        clear-button
        :value="username"
        @input="username = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        type="password"
        placeholder="please input password"
        clear-button
        :value="password"
        @input="password = $event.target.value"
      ></f7-list-input>
    </f7-list>
    <f7-button fill @click="handleLogin">登录</f7-button>
  </div>
</template>
<script>
import { login } from "@/api/user";
import { f7 } from "framework7-vue";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  mounted() {},
  methods: {
    // 与后端 CryptoUtil 一致：AES-256-CBC(随机IV) + HMAC-SHA256，格式 base64(iv):base64(cipher):base64(hmac)
    // 用 crypto-js 而非 Web Crypto，避免 HTTP（非安全上下文）下 crypto.subtle 不可用导致登录失败
    aesEncrypt(plainText) {
      const masterKey = "Xk9mQ2vT7bR4wZ8nF5jC3hL6dP0sA9eG"; // 与后端 login-security.crypto-key 保持一致
      const encKey = CryptoJS.SHA256(masterKey + "enc");
      const macKey = CryptoJS.SHA256(masterKey + "mac");
      const iv = CryptoJS.lib.WordArray.random(16);
      const encrypted = CryptoJS.AES.encrypt(plainText, encKey, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const cipher = encrypted.ciphertext;
      const hmac = CryptoJS.HmacSHA256(iv.clone().concat(cipher), macKey);
      const b64 = (wordArray) => CryptoJS.enc.Base64.stringify(wordArray);
      return `${b64(iv)}:${b64(cipher)}:${b64(hmac)}`;
    },
    async handleLogin() {
      try {
        const res = await login({
          username: this.username,
          password: this.aesEncrypt(this.password),
        });

        this.$store.commit("SET_TOKEN", res.data);

        const toast = f7.toast.create({
          text: "登录成功",
          position: "center",
          closeTimeout: 2000,
        });
        toast.open();
      } catch (error) {
        const toast = f7.toast.create({
          text: "登录失败",
          position: "center",
          closeTimeout: 2000,
        });
        toast.open();
      }
    },
  },
};
</script>
<style scoped>
.content {
  padding: 0 16px;
}
</style>
